// extracted by mini-css-extract-plugin
export default {"ellipsisName":"EntityNameCell_ellipsisName__vbZia","userNameBlock":"EntityNameCell_userNameBlock__P3gQq","boldText":"EntityNameCell_boldText__5-FHv"};